export default "__VITE_ASSET__Pufs_1iY__"